import { memo } from 'react';
import type { ReactNode } from 'react';
import { clsx } from 'clsx';
import styles from './Table.module.scss';

interface TableProps {
    children: ReactNode;
    bordered?: boolean;
    borderedCells?: boolean;
    striped?: boolean;
    collapseBorder?: boolean;
    compact?: boolean;
    medium?: boolean;
    className?: string;
}

const Table = ({
    children,
    bordered,
    striped,
    borderedCells,
    collapseBorder,
    compact,
    medium,
    className = '',
    ...ariaProps
}: TableProps) => {
    return (
        <table
            {...ariaProps}
            className={clsx(styles.table, className, {
                [styles.borderedTable]: bordered,
                [styles.borderedCells]: borderedCells,
                [styles.stripedTable]: striped,
                [styles.collapseBorder]: collapseBorder,
                [styles.compact]: compact,
                [styles.medium]: medium,
            })}
        >
            {children}
        </table>
    );
};

/**
 * @deprecated
 * Please use `Table` from `@library`
 */
export default memo(Table);
